var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.88834 17.6C7.88834 18.48 8.59556 19.2 9.45994 19.2H15.7463C16.6107 19.2 17.3179 18.48 17.3179 17.6V9.6C17.3179 8.72 16.6107 8 15.7463 8H9.45994C8.59556 8 7.88834 8.72 7.88834 9.6V17.6ZM17.3179 5.6H15.3534L14.7955 5.032C14.6541 4.888 14.4498 4.8 14.2455 4.8H10.9608C10.7565 4.8 10.5522 4.888 10.4108 5.032L9.85284 5.6H7.88834C7.45615 5.6 7.10254 5.96 7.10254 6.4C7.10254 6.84 7.45615 7.2 7.88834 7.2H17.3179C17.7501 7.2 18.1037 6.84 18.1037 6.4C18.1037 5.96 17.7501 5.6 17.3179 5.6Z",
    fill: "#49454F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteImg3);
export default __webpack_public_path__ + "static/media/deleteImg3.52b1ef7987026bea3d3d991b5b49ccbb.svg";
export { ForwardRef as ReactComponent };